import React from 'react';

function AgreementStep({ agreements, onAllAgree, onAgreementChange, onOpenModal, validationErrors }) {
  return (
    <div className="bg-gray-50 dark:bg-[#0d1b12] rounded-2xl p-6 border border-gray-200 dark:border-[#1d3324]">
      <div className="flex items-center justify-between mb-4 border-b border-gray-200 dark:border-gray-800 pb-4">
        <label className="flex items-center gap-2 cursor-pointer font-bold text-gray-900 dark:text-white">
          <input type="checkbox" checked={agreements.all} onChange={onAllAgree} className="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary" />
          전체 동의
        </label>
      </div>

      <div className="space-y-3">
        <div className="flex justify-between items-center text-sm">
          <label className="flex items-center gap-2 cursor-pointer text-gray-700 dark:text-gray-300">
            <input type="checkbox" name="terms" checked={agreements.terms} onChange={onAgreementChange} className="rounded border-gray-300 text-primary focus:ring-primary" />
            <span><span className="text-primary-strong font-bold">[필수]</span> 이용약관 동의</span>
          </label>
          <button type="button" onClick={() => onOpenModal('terms')} className="text-xs text-gray-500 underline">보기</button>
        </div>
        {validationErrors.terms && <p className="text-red-500 text-xs pl-6">{validationErrors.terms}</p>}

        <div className="flex justify-between items-center text-sm">
          <label className="flex items-center gap-2 cursor-pointer text-gray-700 dark:text-gray-300">
            <input type="checkbox" name="privacy" checked={agreements.privacy} onChange={onAgreementChange} className="rounded border-gray-300 text-primary focus:ring-primary" />
            <span><span className="text-primary-strong font-bold">[필수]</span> 개인정보 처리방침 동의</span>
          </label>
          <button type="button" onClick={() => onOpenModal('privacy')} className="text-xs text-gray-500 underline">보기</button>
        </div>
        {validationErrors.privacy && <p className="text-red-500 text-xs pl-6">{validationErrors.privacy}</p>}

        <div className="flex justify-between items-center text-sm">
          <label className="flex items-center gap-2 cursor-pointer text-gray-700 dark:text-gray-300">
            <input type="checkbox" name="thirdParty" checked={agreements.thirdParty} onChange={onAgreementChange} className="rounded border-gray-300 text-primary focus:ring-primary" />
            <span><span className="text-primary-strong font-bold">[필수]</span> 개인정보 제3자 제공 동의</span>
          </label>
          <button type="button" onClick={() => onOpenModal('thirdParty')} className="text-xs text-gray-500 underline">보기</button>
        </div>
        {validationErrors.thirdParty && <p className="text-red-500 text-xs pl-6">{validationErrors.thirdParty}</p>}

        <div className="flex justify-between items-center text-sm">
          <label className="flex items-center gap-2 cursor-pointer text-gray-700 dark:text-gray-300">
            <input type="checkbox" name="ageVerified" checked={agreements.ageVerified} onChange={onAgreementChange} className="rounded border-gray-300 text-primary focus:ring-primary" />
            <span><span className="text-primary-strong font-bold">[필수]</span> 만 14세 이상입니다</span>
          </label>
        </div>
        {validationErrors.ageVerified && <p className="text-red-500 text-xs pl-6">{validationErrors.ageVerified}</p>}

        <div className="flex justify-between items-center text-sm">
          <label className="flex items-center gap-2 cursor-pointer text-gray-700 dark:text-gray-300">
            <input type="checkbox" name="marketing" checked={agreements.marketing} onChange={onAgreementChange} className="rounded border-gray-300 text-primary focus:ring-primary" />
            <span><span className="text-gray-400 font-bold">[선택]</span> 마케팅 정보 수신 동의</span>
          </label>
          <button type="button" onClick={() => onOpenModal('marketing')} className="text-xs text-gray-500 underline">보기</button>
        </div>
      </div>
    </div>
  );
}

export default AgreementStep;
